import { render, staticRenderFns } from "./DWTCaptureImage.vue?vue&type=template&id=36ded15d&scoped=true"
import script from "./DWTCaptureImage.vue?vue&type=script&lang=js"
export * from "./DWTCaptureImage.vue?vue&type=script&lang=js"
import style0 from "./DWTCaptureImage.vue?vue&type=style&index=0&id=36ded15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ded15d",
  null
  
)

export default component.exports